import buttons from './buttons';
import colors from './colors';
import general from './general';
import shadows from './shadows';
import sizes from './sizes';
import text from './text';
import transitions from './transitions';
import zIndex from './zIndex';

export default {
    breakpoints: ['1528px'],
    colors: colors.palette,
    fonts: text.fonts,
    fontWeights: text.fontWeights,
    styles: {
        ...general.body
    },
    shadows,
    sizes,
    transitions,
    zIndex,
    // variants
    buttons: buttons.variants,
    text: text.variants
};
